import React from "react";
import { Select as SelectPrimitive } from "radix-ui";
import { cn } from "@/lib/utils";

export function FilterSelect({ value, onValueChange, placeholder, children, className }) {
  return (
    <SelectPrimitive.Root value={value} onValueChange={onValueChange}>
      <SelectPrimitive.Trigger
        className={cn(
          "group flex items-center justify-between w-[183px] h-9 px-3 gap-2 rounded-[5px] border-2 border-nav-active bg-card-bg text-sm font-medium text-nav-active cursor-pointer outline-none shrink-0 hover:border-nav-active-hover hover:text-nav-active-hover transition-colors",
          className
        )}
      >
        <SelectPrimitive.Value placeholder={placeholder} />
        <SelectPrimitive.Icon asChild>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className="shrink-0 transition-transform group-data-[state=open]:rotate-180"
          >
            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content
          position="popper"
          sideOffset={4}
          className="z-50 min-w-[var(--radix-select-trigger-width)] rounded-[5px] bg-card-bg shadow-lg overflow-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2"
        >
          <SelectPrimitive.Viewport className="overflow-y-auto max-h-[min(320px,var(--radix-select-content-available-height))]">
            {children}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  );
}

export function FilterSelectItem({ value, children }) {
  return (
    <SelectPrimitive.Item
      value={value}
      className="flex items-center h-[30px] px-4 text-sm font-medium text-nav-active-hover cursor-pointer outline-none select-none transition-colors data-[highlighted]:text-nav-active data-[state=checked]:font-bold first:mt-[10px] last:mb-[10px]"
    >
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  );
}
